module.exports = __webpack_public_path__ + "static/solution13-b50dc92d821ba072b3e71645a5e8afbd.png";